import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { PageHero } from "../components/blocks";
import { Reveal } from "../components/motion/Reveal";

function LegalContent({ data, testid }) {
  return (
    <div data-testid={testid}>
      <PageHero overline={data.updated} title={data.title} />
      <section className="bg-brand-beige py-24 md:py-32">
        <div className="mx-auto max-w-3xl px-6 md:px-12">
          <div className="space-y-14">
            {data.sections.map((s, i) => (
              <Reveal key={i} variant="up" delay={i * 0.05}>
                <h2 className="font-serif text-2xl text-brand-green md:text-3xl">{s.heading}</h2>
                <p className="mt-4 text-lg leading-relaxed text-brand-black/75">{s.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export function Privacy() {
  const { content } = useLanguage();
  return <LegalContent data={content.legal.privacy} testid="privacy-page" />;
}

export function Mentions() {
  const { content } = useLanguage();
  return <LegalContent data={content.legal.mentions} testid="mentions-page" />;
}
